// import React, { useState, useEffect } from 'react';

// // Importa las funciones de tu BL
// import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from '../../utilities/BL/Zones';
// import { GetLineup } from '../../utilities/BL/Lineup';

// // Importa el componente visual hijo
// import { Lineup as LineupOverlay } from './Overlays/Lineup';

// /**
//  * COMPONENTE: LINEUP OVERLAY (PARENT CONTAINER)
//  * ------------------------------------------------------------------
//  * Este componente es el "Cerebro" del Overlay. 
//  * 1. Establece la conexión WebSocket como "overlay:lineup".
//  * 2. Escucha los mensajes entrantes.
//  * 3. Pasa la información al componente visual <Lineup />.
//  * ------------------------------------------------------------------
//  */
// const Lineup = () => {
//     // --- ESTADOS DE CONEXIÓN Y DATOS ---
//     const [lineupData, setLineupData] = useState(null); // Payload para el hijo
//     const [connectionStatus, setConnectionStatus] = useState('idle');

//     // -------------------------------------------------------------------------
//     // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         // 1. HIDRATACIÓN INICIAL (Buscar datos de la BD al abrir OBS)
//         const loadInitialData = async () => {
//             const res = await GetLineup('Local'); // Por defecto cargamos el Local
//             if (res.success && res.data) {
//                 setLineupData({ type: 'lineup.state_update', data: res.data });
//             }
//         };
        
//         // 2. Definir la función de conexión
//         const connect = async () => {
//             await ConnectWebSocketForOverlay(
//                 'alineacion', 
//                 (status) => setConnectionStatus(status),
//                 (msg) => console.log('[Overlay] Toast:', msg)
//             );

//             // Asignamos el manejador de mensajes
//             SetSocketMessageHandler(handleIncomingMessage);
//         };

//         const handleIncomingMessage = (message) => {
//             if (!message || !message.type) return;

//             // Filtramos los mensajes que pertenecen estrictamente al módulo de alineación
//             if (message.type === 'lineup.state_update' || message.type === 'lineup.presentation') {
//                 setLineupData(prev => {
//                     if (JSON.stringify(prev) === JSON.stringify(message)) return prev;
//                     return { ...message };
//                 });
//             }
//         };

//         // 3. Ejecutar flujo
//         loadInitialData();
//         connect();

//         // 4. Cleanup al desmontar
//         return () => {
//             ClearSocketMessageHandler();
//             DisconnectWebSocket();
//         };
//     }, []);

//     // -------------------------------------------------------------------------
//     // RENDERIZADO
//     // -------------------------------------------------------------------------
//     return (
//         <>
//             <LineupOverlay data={lineupData} />

//             {/* Indicador de error de conexión (útil para debug en OBS) */}
//             {connectionStatus === 'error' && (
//                 <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 5, fontSize: 10, zIndex: 9999 }}>D</div>
//             )}
//         </>
//     );
// };

// export { Lineup };









import React, { useState, useEffect } from 'react'

// Importa las funciones de tu BL (ajusta la ruta según tu estructura)
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from '../../utilities/BL/Zones'

// Importa el componente visual hijo (el que tiene los estilos y animación)
import { Lineup as LineupOverlay } from './Overlays/Lineup'

import { GetLineup } from '../../utilities/BL/Lineup';


/**
 * COMPONENTE: LINEUP OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * Este componente es el "Cerebro" del Overlay. 
 * 1. Establece la conexión WebSocket como "overlay:lineup".
 * 2. Escucha los mensajes entrantes.
 * 3. Pasa la información al componente visual <Lineup />.
 * ------------------------------------------------------------------
 */
const Lineup = () => {
    // --- ESTADOS DE CONEXIÓN Y DATOS ---
    const [lineupData, setLineupData] = useState(null); // Payload para el hijo
    const [connectionStatus, setConnectionStatus] = useState('idle');
    
    //const [isBoardVisible, setIsBoardVisible] = useState(true);

    // Opcional: Si necesitas manejar el modo femenil/varonil aquí también
    // const [isActiveWomensMode, setIsActiveWomensMode] = useState(false); 

    // -------------------------------------------------------------------------
    // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
    // -------------------------------------------------------------------------
    useEffect(() => {
        // 1. HIDRATACIÓN INICIAL (Buscar datos de la BD al abrir OBS)
        const loadInitialData = async () => {
            const res = await GetLineup('Local'); // Por defecto cargamos el Local
            if (res.success && res.data) {
                setLineupData({ type: 'lineup.state_update', data: res.data });
            }
        };
        
        // 1. Definir la función de conexión
        const connect = async () => {
            // Llamamos a la nueva función del BL especificando 'lineup'
            await ConnectWebSocketForOverlay(
                'alineacion', 
                (status) => setConnectionStatus(status),
                (msg) => console.log('[Overlay] Toast:', msg) // O tu lógica de toast
            );

            // Asignamos el manejador de mensajes
            SetSocketMessageHandler(handleIncomingMessage);
        };

        // const handleIncomingMessage = (message) => {
        //     if (!message || !message.type) return;

        //     if (message.type === 'score.state_update') {
        //         // Forzamos un objeto nuevo para que React detecte el cambio
        //         setLineupData({ ...message }); 
        //     } else if (message.type === 'score.notification') {
        //         setLineupData({ ...message });
        //     }
        // };

        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            // NUEVO: Manejo de visibilidad
            // if (message.type === 'lineup.presentation') {
            //     const { action } = message.data;
            //     if (action === 'show_board') { setIsBoardVisible(true); return; }
            //     if (action === 'hide_board') { setIsBoardVisible(false); return; }
            // }

            // Cambia los tipos para que coincidan con los definidos en LineupService.cs
            if (message.type === 'lineup.state_update' || message.type === 'lineup.presentation') {
                //setLineupData({ ...message }); 
                setLineupData(prev => {
                    if (JSON.stringify(prev) === JSON.stringify(message)) return prev;
                    return { ...message };
                });
            }
        };

        // 3. Ejecutar conexión
        loadInitialData();
        connect();

        // 4. Cleanup al desmontar
        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, []);

    // -------------------------------------------------------------------------
    // RENDERIZADO
    // -------------------------------------------------------------------------
    return (
        <>
            {/* Renderizamos el componente visual pasándole la data del socket.
                Si tuvieras lógica de Modo Femenil, pásala aquí también.
            */}
            <LineupOverlay data={lineupData} /> {/* isActiveWomensMode={isActiveWomensMode} */}

            {/* Opcional: Indicador de error de conexión (útil para debug en OBS) */}
            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 5, fontSize: 10 }}>D</div>
            )}
        </>
    );
};

export { Lineup };